export enum CompanySectionBlock {
  Root = 'CompanySection',
}
